package io.horion.cv.models

data class User(
    val id: String = "",
    val nom: String = "",               // Nom de l’enterprise
    var email: String= "",                            // Titre du poste (ex: "Développeur Android")
    var phone: String= "",                             // Lieu (ex: "Douala, Cameroun")
)
